import { trackableParams } from './params';

export function enabled() {
  return !!window.newrelic;
}

export function track(eventName, args) {
  if (enabled()) window.newrelic.addPageAction(eventName, args);
}

export function setup() {
  if (!enabled()) return;
  const params = trackableParams();
  for (let key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key) && params[key]) {
      window.newrelic.setCustomAttribute(key, params[key]);
    }
  }
}
